"use strict";

if (document.getElementById("app_private_header")) {
  var vuePrivateHeader = new Vue({
    delimiters: ['[[', ']]'],
    el: '#app_private_header',
    data: {
      id: window.user_id,
      connectedLawyer: 0,
      nameLawyer: '',
      imgLawyer: ''
    },
    mounted: function mounted() {
      $.ajaxSetup({
        traditional: true
      });
    },
    methods: {
      getLawyer: function getLawyer() {
        var urlApi = '/api/v1/lawyers/' + vuePrivateHeader.id;
        $.ajax({
          url: urlApi,
          method: 'GET',
          beforeSend: function beforeSend(request) {
            return request.setRequestHeader("Accept-Language", languageCode);
          },
          success: function success(response) {
            vuePrivateHeader.connectedLawyer = vuePrivateHeader.id;
            vuePrivateHeader.nameLawyer = response.first_name + ' ' + response.last_name;

            if (response.image) {
              vuePrivateHeader.imgLawyer = 'background-image: url(' + response.image_obj.thumbnail_url + ')';
            } else {
              vuePrivateHeader.imgLawyer = 'background-image: url(/static/img/no-avatar.png)';
            }
          },
          error: function error(_error) {
            console.log(_error);
          }
        });
      }
    }
  });

  if (vuePrivateHeader.id) {
    vuePrivateHeader.getLawyer();
  }
}